import React, { useEffect } from 'react';
import { Nav } from './nav.tsx';
import { Footer } from './footer.tsx';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';
import '../css/press.css';

export function Press() {
    const { lang } = useParams();
    const { t } = useTranslation();
    const baseURL = "https://www.parlaretail.com";
    useEffect(() => {
        if (lang) {
            i18next.changeLanguage(lang);
        }
    }, [lang]);

    const articles = t('press.articles', { returnObjects: true }) as {
        title: string;
        subtitle?: string;
        date: string;
        location: string;
        content: string[];
        contact?: { name: string; email: string };
        about: string;
    }[];

    return (
        <>
            <Helmet key={lang}>
                {/* General Meta */}
                <meta charSet="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <title>{t('press.meta.title')}</title>
                <meta name="description" content={t('press.meta.description')} />
                <meta name="keywords" content={t('press.meta.keywords')} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content={t('press.meta.title')} />
                <meta property="og:description" content={t('press.meta.description')} />
                <meta property="og:url" content={`${baseURL}/${lang}/`} />
                <meta property="og:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t('press.meta.title')} />
                <meta name="twitter:description" content={t('press.meta.description')} />
                <meta name="twitter:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Hreflang for Language Versioning */}
                <link rel="alternate" hrefLang="en" href={`${baseURL}/en/`} />
                <link rel="alternate" hrefLang="es" href={`${baseURL}/es/`} />

                {/* Favicon */}
                <link rel="icon" type="image/png" href={`${baseURL}/img/parla-fav.png`} />
            </Helmet>
            <Nav />
            <div className="page">
                <div className="">
                    <div className="row f70 t-center t-color-2 p20">Latest News</div>

                    {articles.map((article, index) => (
                        <div key={index} className="section-column partners">
                            <div className="card-holder w80">
                                <div className="press-block">
                                    <h2 className="t-center">{article.title}</h2>
                                    {article.subtitle && <p className="t-center italic pt20">{article.subtitle}</p>}
                                    <p className="pt20">
                                        <strong>{article.date}</strong>
                                    </p>
                                    <p className="pt20">
                                        <strong>{article.location}</strong>
                                    </p>
                                    {article.content.map((paragraph, idx) => (
                                        <p className="pt20" key={idx} dangerouslySetInnerHTML={{ __html: paragraph }} />
                                    ))}
                                    {article.contact && (
                                        <>
                                            <h3 className="pt20">{t('press.contact_title')}</h3>
                                            <p className="pt10">
                                                {article.contact.name}
                                                <br />
                                                <a href={`mailto:${article.contact.email}`}>{article.contact.email}</a>
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
}
